import { CreateWithBudButton } from "../../assistant/components/CreateWithBudButton";
import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { Grid, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { withPageTracking } from "../../../services/postHog";
import { ActionCard } from "../../../shared-components/ActionCards";

const AssignmentCreate = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const classId = searchParams.get("classId");
  const createGroupWithName = searchParams.get("createGroupWithName");

  const handleAddNewClicked = () => {
    const params = new URLSearchParams();
    if (classId) params.set("classId", classId);
    if (createGroupWithName)
      params.set("createGroupWithName", createGroupWithName);
    navigate(`new${params.toString() ? `?${params.toString()}` : ""}`);
  };

  const handleExistingClicked = () => {
    const params = new URLSearchParams();
    if (classId) params.set("classId", classId);
    if (createGroupWithName)
      params.set("createGroupWithName", createGroupWithName);
    navigate(
      `from-existing${params.toString() ? `?${params.toString()}` : ""}`,
    );
  };
  return (
    <FruitifyContainer>
      <Typography variant="h3" fontWeight="bold">
        Create assignment
      </Typography>
      <Grid container spacing={2} sx={{ width: "100%", mt: 2 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <ActionCard
            title="Create a new assignment"
            subtitle="Create an assignment from scratch using new or existing questions"
            iconName="Edit"
            onAdd={handleAddNewClicked}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <CreateWithBudButton kind="assignment" classId={classId} asCard />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <ActionCard
            title="Choose existing assignments"
            subtitle="Browse and select from previously created assignments."
            iconName="FolderOpen"
            onAdd={handleExistingClicked}
          />
        </Grid>
      </Grid>
    </FruitifyContainer>
  );
};

export default withPageTracking(AssignmentCreate, {
  feature: "assigment-create",
});
